import type { Filters, SearchId } from '@/domain';
import { useExactPriceSearch } from './useExactPriceSearch';
import { useListSearch } from './useListSearch';

interface UseFhhSearchProps {
    searchId: SearchId;
    effectiveFilters: Filters;
}

export const useFhhSearch = ({ searchId, effectiveFilters }: UseFhhSearchProps) => {
    const hasSearchId = Boolean(searchId);

    const exactPriceResult = useExactPriceSearch(searchId || '', effectiveFilters, hasSearchId);
    const listResult = useListSearch(effectiveFilters, !hasSearchId);

    return hasSearchId ? exactPriceResult : listResult;
};
